import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import DatePicker from "vue2-datepicker";
import { IOtherAppointment } from "@/models";
import { ToastHelper } from "@/helpers/ToastHelper";

import moment from "moment";

@Component({
    name: "otherappointment-create",
    components: {
        datepicker: DatePicker,
    },
})

export default class OtherAppointmentCreate extends Vue {
    public otherAppointment: IOtherAppointment = null;

    public readonly newOtherAppointmentModal = "newOtherAppointmentModal";

    public constructor() {
        super();
    }

    public created(): void {
        this.otherAppointment = {
            date: moment().hours(12).minutes(0).format("YYYY-MM-DD HH:mm"),
            otherAppointmentId: 0,
            slotId: 0,
            title: "",
        };
    }

    public mounted(): void {
        this.$modal.show(this.newOtherAppointmentModal);
    }

    public get notBefore(): Date {
        return moment().hours(0).minutes(0).toDate();
    }

    public validateOther(): void {
        if (this.otherAppointment.date !== "" && this.otherAppointment.title !== "") {
            this.otherAppointment.date = moment(this.otherAppointment.date).toISOString(true);

            this.$store.dispatch("otherAppointments/addOtherAppoitnment", this.otherAppointment).then(() => {
                this.$modal.hide(this.newOtherAppointmentModal);
                this.emitEvent();
            });
        } else {
            ToastHelper.general.invalidModel();
        }
    }

    public emitEvent(): void {
        this.$emit("change");
    }
}
